import http from "@/utils/axios";
import cookie from "@/utils/cookie";

const state = {
  userId:'',
  userShare:{},
  latestLoginRcrd: {},
  appid:null,
  agentid:null,
  refreshBaseFlag:false,
  refreshHeadFlag:false,
}

const mutations = {
  getUserInfo(state,obj){
    let token = cookie.getCookie("token");
    http.post(window.config.api.baseUrl + '/eims-api/user/share/userInfo', {
      token: token,
      data:{}
    }).then(response => {
      if (response.data.code == '00000'){
        state.userShare = response.data.data.userShare;
        state.latestLoginRcrd = response.data.data.latestLoginRcrd
      }
    })
  },

  getEimsUser(state, obj){
    state.userId = obj.userId;
  },

  clearEimsUser(state){
    state.userId = '';
  },

  changeRefreshFlag(state, obj){
    obj.baseFlag!=undefined?state.refreshBaseFlag = obj.baseFlag:'';
    obj.headFlag!=undefined?state.refreshHeadFlag = obj.headFlag:'';
  },

  getQrCodeParams(state, obj){
    http.post(window.config.api.baseUrl + '/eims-api/user/qrCodeParams', {
      data:{}
    }).then(response => {
      if (response.data.code == '00000'){
        state.appid = response.data.data.appid
        state.agentid = response.data.data.agentid
      }
    })
  },
}

const actions = {
  getUserInfo:({commit, state}, obj) => commit("getUserInfo", obj),
  getEimsUser:({commit, state}, obj) => commit("getEimsUser", obj),
  clearEimsUser:({commit, state}, obj) => commit("clearEimsUser", obj),
  getQrCodeParams:({commit, state}, obj) => commit("getQrCodeParams", obj),
  changeRefreshFlag:({commit, state}, obj) => commit("changeRefreshFlag", obj),
}

export default {
  state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/userModule.js